<template>                                    
<div>
<form novalidate class="md-layout" @submit.prevent="validateUser('anfrage')">
    <md-card class="md-layout-item md-size-100 md-small-size-100">
      <md-card-header>
      <div class="md-title">Unterlagen anfordern</div>
      <div class="md-subtitle">
        Erfahren Sie mehr über Ihre Favoriten. Mögliche Verfügbarkeiten, sowie bisherige Referenzen. Wir melden uns schnellstmöglich bei Ihnen.
    </div>
    </md-card-header>

    <md-card-content>
      <div class="md-layout md-gutter" style=padding:0px;>
        <div class="md-layout-item md-small-size-100">
          <md-field :class="getValidationClass('firstName')">
            <label for="first-name">Vorname</label>
            <md-input name="first-name" id="first-name" autocomplete="given-name" v-model="form.firstName" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.firstName.required">Das Feld Vorname ist erforderlich</span>
            <span class="md-error" v-else-if="!$v.form.firstName.minlength">Ungültiger Vorname</span>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100">
          <md-field :class="getValidationClass('lastName')">
          <label for="last-name">Nachname</label>
          <md-input name="last-name" id="last-name" autocomplete="family-name" v-model="form.lastName" :disabled="sending" />
          <span class="md-error" v-if="!$v.form.lastName.required">Das Feld Nachname ist erforderlich</span>
          <span class="md-error" v-else-if="!$v.form.lastName.minlength">Ungültiger Nachname</span>
        </md-field>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-small-size-100">
      <md-field :class="getValidationClass('emailAddressPrivate')">
        <label for="email">E-Mail</label>
        <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.emailAddressPrivate" :disabled="sending" />
        <span class="md-error" v-if="!$v.form.emailAddressPrivate.required">Das Feld E-Mail ist erforderlich</span>
        <span class="md-error" v-else-if="!$v.form.emailAddressPrivate.email">Bitte geben Sie eine gültige E-Mail Adresse ein</span>
      </md-field>
        </div>
        <div class="md-layout-item md-small-size-100">
          <md-field :class="getValidationClass('phoneNumberBusiness')">
          <label for="number">Ihre Telefonnummer</label>
          <md-input type="number" id="number" name="number" autocomplete="number" v-model="form.phoneNumberBusiness" :disabled="sending" />
          <span class="md-error" v-if="!$v.form.phoneNumberBusiness.required">Das Feld Telefonnummer ist erforderlich</span>
          <span class="md-error" v-else-if="!$v.form.phoneNumberBusiness.maxlength">Bitte geben Sie eine gültige Telefonnummer ein</span>
        </md-field>
        </div>
      </div>
        <div class="md-layout-item md-small-size-100">
          <md-field :class="getValidationClass('jobTitle')">
            <label for="jobTitle">Unternehmen</label>
            <md-input name="position" id="position" v-model="form.jobTitle" md-dense :disabled="sending">
            </md-input>
            <span class="md-error" v-if="!$v.form.jobTitle.required">Das Feld Position ist erforderlich</span>
          </md-field>
        </div>
        <md-field>
        <label for="email">Ihre Nachricht</label>
          <md-textarea type="textarea" id="number" name="number" autocomplete="number" v-model="form.message" :disabled="sending" />
      </md-field>
      <div class="md-layout-item">
      <md-field class="checkbox" :class="getValidationClass('datenschutz')">
        <md-checkbox v-model="form.datenschutz" value="my-checkbox">Hiermit bestätige ich die 
            <router-link v-bind:to="'/datenschutz'" exact>
            <a> Datenschutzbestimmungen</a>
           </router-link>
           <br>
          <!-- <span style="font-size:10px;">Das Kleingedruckte</span> -->
        </md-checkbox>
        <span class="md-error" v-if="!$v.form.datenschutz.required">Bitte bestätigen Sie die Datenschutzbestimmung.</span>
        </md-field>
        </div>
    </md-card-content>

    <md-progress-bar md-mode="indeterminate" v-if="sending" />

    <md-card-actions> 
          <md-button @click="formType('anfrage')" type="submit" class="md-primary" :disabled="sending">senden</md-button>
    </md-card-actions>
  </md-card>
  <!-- <md-snackbar :md-active.sync="userSaved">Liebe/r {{ lastUser }}, wir haben Ihre Bewerbung erhalten</md-snackbar> -->
  </form>
</div>
       
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { validationMixin } from 'vuelidate' 

import {
    required,
    minLength,
    maxLength,
    email
  } from 'vuelidate/lib/validators'

export default {
name: 'InquiryForm',
mixins: [validationMixin],
 data: () => ({
    active: false,
    value: null,
    firstName: "",
    lastName: "",
    jobTitle: "",
    emailAddressPrivate: "",
    phoneNumberBusiness: "",
    message:"",
    sending: false,
    userSaved: false,
    lastUser: null,
    cartItems: ['ids:'],
    formtype: null,
    form: {
      formtype: null,
      firstName: null,
      lastName: null,
      jobTitle: null,
      emailAddressPrivate: null,
      phoneNumberBusiness: null,
      datenschutz: null,
      message:null
    }
}),
 validations: {
      form: {
        firstName: {
          required,
          minLength: minLength(2)
        },
        lastName: {
          required,
          minLength: minLength(2)
        },
        jobTitle: {
          required,
          maxLength: maxLength(40)
        },
        message: {
          maxLength: maxLength(500)
        },
        emailAddressPrivate: {
          required,
          email
        },
        phoneNumberBusiness: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(15)
        },
        datenschutz: {
          required
        }
      }
    },
computed: {
  ...mapState({
    candidates: state => state.candidates.candidates,
    cart: state => state.cart.cart
  })
},
methods: {
  ...mapActions('candidates',
      ['addCandidate',
      'getCandidates',
      'deleteCandidate'
    ]),
    getValidationClass (fieldName) {
    const field = this.$v.form[fieldName]

    if (field) {
        return {
        'md-invalid': field.$invalid && field.$dirty
        }
    }},
    clearForm () {
        this.$v.$reset()
        this.form.formtype = null
        this.form.firstName = null
        this.form.lastName = null
        this.form.jobTitle = null
        this.form.emailAddressPrivate = null
        this.form.phoneNumberBusiness = null
        this.form.message = null
      },
    saveUser () {
        this.sending = true
        // Instead of this timeout, here you can call your API
        window.setTimeout(() => {
          this.lastUser = `${this.form.firstName} ${this.form.lastName}`
          this.userSaved = true
          this.sending = false
          this.$emit('close-cart')
          this.$emit('message-sent')
          this.$emit('empty-cart')
          this.clearForm()
        }, 1500)
      },
      validateUser (type) {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.saveUser()
          this.addCandidate({ 
            cartItems: this.getCartItemsStore().toString(),
            formtype: type,
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            jobTitle: this.form.jobTitle,
            emailAddressPrivate: this.form.emailAddressPrivate,
            phoneNumberBusiness: this.form.phoneNumberBusiness,
            message: this.form.message
            })
            // this.emptyCart()
        }
      },
      getCartItemsStore () {
        for(var i in this.$store.state.cart.cart) {
          var item = this.$store.state.cart.cart[i];
          if (item.addtoCart) {
            this.cartItems.push(item.carerix_id)
            }
          }
        return this.cartItems
      },
  }
}
</script>

<style lang="scss">
@import '../assets/css/shared.scss';

.md-checkbox .md-checkbox-label {
    height: 20px;
    padding-left: 16px;
    position: relative;
    line-height: 13px !important;
}

</style>
